import { ShopifyAppName } from '__generated__/atlas-types'

const getShopifyAppName = (appName?: ShopifyAppName) =>
  appName === ShopifyAppName.BRAND_SYNC
    ? process.env.REACT_APP_SHOPIFY_BRAND_SYNC_APP_NAME
    : process.env.REACT_APP_SHOPIFY_APP_NAME

export const getShopifyAppUrl = (appName?: ShopifyAppName) =>
  `https://apps.shopify.com/${getShopifyAppName(appName)}`

export const getShopifyAppPricingUrl = (
  shopSlug: string,
  appName?: ShopifyAppName,
) =>
  `https://admin.shopify.com/store/${shopSlug}/charges/${getShopifyAppName(appName)}/pricing_plans`
